// import React, { useState } from "react";

// const SearchBar = ({ onSearch }) => {
//   const [selectedOption, setSelectedOption] = useState("module");
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleOptionChange = (e) => {
//     setSelectedOption(e.target.value);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (!searchQuery.trim()) {
//       return; // If the search query is empty, do not perform the search
//     }
//     onSearch(selectedOption, searchQuery);
//   };

//   return (
//     <div className="flex items-center justify-center my-[2em]">
//       <form
//         className="flex relative w-[900px] bg-gradient-to-r from-purple-500 to-indigo-500 rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-2xl"
//         onSubmit={handleSearchSubmit}
//       >
//         <div className="flex justify-center">
//           <select
//             value={selectedOption}
//             onChange={handleOptionChange}
//             className="bg-white text-gray-700 px-3 h-12 outline-none border-r-2 border-gray-300 rounded-l-lg transition-colors duration-300"
//           >
//             <option className="bg-white" value="module">
//               Module Serial Number
//             </option>
//             <option className="bg-white" value="pallet">
//               Pallet Number
//             </option>
//             <option className="bg-white" value="container">
//               Container Number
//             </option>
//           </select>
//         </div>
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={handleSearchChange}
//           placeholder="Search by Module no, Serial no, Container no or Pallet no...."
//           className="w-full h-12 pl-4 pr-10 text-gray-700 placeholder-gray-500 rounded-r-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-300"
//         />
//         <div className="absolute inset-y-0 right-0 flex items-center pr-4">
//           <button
//             type="submit"
//             className="text-gray-700 hover:text-indigo-300 transition-colors duration-300 focus:outline-none"
//           >
//             <svg
//               className="w-6 h-6"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M21 21l-4.35-4.35m1.35-6.15a7 7 0 11-14 0 7 7 0 0114 0z"
//               ></path>
//             </svg>
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default SearchBar;


import React, { useState, useEffect } from "react";

const SearchBar = ({ onSearch }) => {
  const [selectedOption, setSelectedOption] = useState("module");
  const [searchQuery, setSearchQuery] = useState("");

  // Listen for QR code scans
  useEffect(() => {
    const handleScannerInput = (event) => {
      const scannedData = event.target.value; 
      if (scannedData) {
        setSearchQuery(scannedData); 
      }

      console.log("SearchBar component mounted: ", scannedData);
    };

    const inputField = document.getElementById("scanner-input");
    if (inputField) {
      inputField.addEventListener("input", handleScannerInput);
    }

    return () => {
      if (inputField) {
        inputField.removeEventListener("input", handleScannerInput);
      }
    };
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) {
      return; 
    }
    onSearch(selectedOption, searchQuery);
  };

  return (
    <div className="flex items-center justify-center my-[2em]">
      <form
        className="flex relative w-[900px] bg-gradient-to-r from-purple-500 to-indigo-500 rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-2xl"
        onSubmit={handleSearchSubmit}
      >
        <div className="flex justify-center">
          <select
            value={selectedOption}
            onChange={handleOptionChange}
            className="bg-white text-gray-700 px-3 h-12 outline-none border-r-2 border-gray-300 rounded-l-lg transition-colors duration-300"
          >
            <option className="bg-white" value="module">
              Module Serial Number
            </option>
            <option className="bg-white" value="pallet">
              Pallet Number
            </option>
            <option className="bg-white" value="container">
              Container Number
            </option>
          </select>
        </div>
        <input
          id="scanner-input"
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value.trim())}
          placeholder="Scan or Search by Module no, Serial no, Container no or Pallet no...."
          className="w-full h-12 pl-4 pr-10 text-gray-700 placeholder-gray-500 rounded-r-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-300"
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-4">
          <button
            type="submit"
            className="text-gray-700 hover:text-indigo-300 transition-colors duration-300 focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m1.35-6.15a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;

